
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M13 13H3V5h10M3 1a1.993 1.993 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m-1 7H8v4h4Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  